import { On3IconSearch } from '@on3/icons';
import { Link } from '@on3/ui-lib/components/Link';
import { useAuth, useSite } from '@on3/ui-lib/index';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import { AthleteClaimButton } from '@public/components/Db/Profile/AthleteClaim/AthleteClaimButton';
import { useHeader } from '@public/components/Header';
import { UserMenu } from '@public/components/Header/UserMenu';
import { JoinButton } from '@public/components/Subscription/JoinButton';
import { AdFreeCta } from '@public/components/UI/AdFreeCta';
import { useAthlete } from '@public/contexts/AthleteProvider';
import clsx from 'clsx';

import styles from './Auth.module.scss';

export const Auth = ({ isSubscribe }: { isSubscribe?: boolean }) => {
  const { user } = useAuth();
  const { currentSite } = useSite();
  const { athlete, hasBaseProfile } = useAthlete();
  const { formatHref, router } = useDynamicRoute();
  const {
    themes: {
      isSoftballAmerica,
      isHighSchool,
      isLogin,
      isTeam,
      isRivalsTeam,
      isHighSchoolTeam,
      isRecruits,
    },
  } = useHeader();

  const returnto = router.query.returnto as string;
  const hasReturnTo = !!returnto;
  const isRivals = currentSite.resourceId === 'R44_RIVALS';

  const hasSub = !!user?.has;
  const showClaimProfile =
    hasBaseProfile && !athlete?.athleteVerified && !isRecruits;
  const showBasicJoin =
    !hasSub &&
    !isTeam &&
    !isRivalsTeam &&
    !isSubscribe &&
    !isSoftballAmerica &&
    !isHighSchool &&
    !isHighSchoolTeam &&
    !showClaimProfile &&
    !isRecruits;
  const showJoin =
    !hasSub &&
    (isTeam || isSoftballAmerica || isRivalsTeam || isHighSchoolTeam) &&
    !isSubscribe &&
    !isHighSchool &&
    !showClaimProfile &&
    !isRecruits;
  const showAdFree = !isRecruits && !showClaimProfile;
  const showRecruitsJoin = isRecruits;
  const basicJoinLink = isRivals ? '/rivals/join/' : '/join/';

  return (
    <div className={styles.block} data-menu-ui="auth">
      <Link
        className={styles.search}
        data-auth-ui="search"
        href="/rivals/search/"
        title="Rivals Database Hub"
      >
        <On3IconSearch fill="currentColor" height="16px" width="16px" />
      </Link>
      {showBasicJoin && (
        <Link className={styles.joinLink} data-join href={basicJoinLink}>
          {currentSite?.subscribeText || 'Join'}
        </Link>
      )}
      {showRecruitsJoin && (
        <Link className={styles.joinLink} data-join href="/recruits/search/">
          {currentSite?.subscribeText || 'Join Now'}
        </Link>
      )}
      {showJoin && <JoinButton className={styles.join} />}
      {showClaimProfile && <AthleteClaimButton className={styles.claim} />}
      {showAdFree && <AdFreeCta hide={isSubscribe} />}
      {user?.a ? (
        <UserMenu />
      ) : !isLogin ? (
        <Link
          className={clsx(styles.login, { [styles.show]: isSubscribe })}
          href={formatHref({
            path: `/[slug]/login/`,
            params: {
              slug: isTeam ? currentSite?.url || '' : '',
            },
            query: {
              returnTo: hasReturnTo ? returnto : router.asPath,
            },
          })}
        >
          Login
        </Link>
      ) : null}
    </div>
  );
};
